import React from "react";
import { useSelector } from "react-redux";

import { FlightsRebookSelectors } from "@b2bportal/core-flights-rebook";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { RebookSummaryContentProps } from "./types";

export const useRebookSummaryContent = ({
  data,
  goToNextStep,
}: RebookSummaryContentProps) => {
  const { t } = useI18nContext();

  const lastSegment = React.useMemo(
    () => data.slices[0].segments[data.slices[0].segments.length - 1],
    [data]
  );
  const destinationCode = lastSegment.destination.locationCode;
  const destinationName =
    data.tripContext?.airports[destinationCode]?.cityName ?? destinationCode;

  const selectedSegment = useSelector(
    FlightsRebookSelectors.getSelectedSegment
  );

  return React.useMemo(
    () => ({
      text: {
        destinationName,
        destinationCode,
        rebookButton: t("core-flights.rebook.summary.rebook-button"),
      },
      context: {
        rebookButtonDisabled: selectedSegment == null,
      },
      handlers: {
        rebookClick:
          selectedSegment == null
            ? undefined
            : () => {
                goToNextStep();
              },
      },
    }),
    [destinationCode, destinationName, goToNextStep, selectedSegment, t]
  );
};
